import React, { useEffect, useState } from "react";

const SuccessMessage = ({ message, countdownTime, onCountdownComplete }) => {
  const [countdown, setCountdown] = useState(countdownTime);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      onCountdownComplete();
    }
  }, [countdown, onCountdownComplete]);

  return (
    <>
      {" "}
      <div className="modal-overlay-UOD">
        <div className="modal-container-2-UOD">
          <div className="modal-header-UOD">
            <h2>File uploading </h2>
          </div>
          <div className="modal-body-UOD">
            <p className="text-p-UOD">
              Please wait for the files to be uploaded 
            </p>
            <p className="text-p-UOD">
             {message} Time remaining {countdown} seconds.
            </p>
          </div>
        </div>
      </div>{" "}
      <div className="successDivMessage">
       
      </div>
    </>
  );
};

export default SuccessMessage;
